<template>
  <v-flex xs12>
    <h2 class="nx-heading--level-1 mb-4">{{ $t('message.permissions.filters.chooseWorkflow') }}</h2>
    <v-checkbox v-for="state in availableStates"
                :key="state.id"
                multiple
                class="my-0 py-0"
                v-model="filterValue"
                :label="state.name"
                :value="state"></v-checkbox>
  </v-flex>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import store from '@/store';

export default {
  name: 'nx-authorization-permissions-wizard-workflow-filter',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      filterValue: null,
    };
  },
  computed: {
    availableStates() {
      const states = store.getters.authorization.workflowStates;
      console.debug(states);
      return states || [];
    },
    filters() {
      if (isEmpty(this.filterValue)) {
        return [];
      }
      return {
        state: this.filterValue,
      };
    },
  },
  watch: {
    filters(value) {
      this.$emit('input', value);
    },
  },
};
</script>
